// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import React from 'react'
import TooltipContext from './TooltipContext'

const withTooltipContext = Component => (
  React.memo(props => (
    <TooltipContext.Consumer>
      {({ triggerTooltip }) => (
        <Component
          triggerTooltip={triggerTooltip}
          {...props} />
      )}
    </TooltipContext.Consumer>
  ))
)

export default withTooltipContext
